import { Box } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { VALIDATION_VENTE } from "../../Utils/constant";
import ok from "../../assets/images/ok.png";
import { store } from "../../services/service";
import { SubmitButton } from "../Widget/SubmitButton";
export const ActivationEnLigne = ({ numeroTicket }) => {
  const [statusOk, setStatusOk] = useState("");
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const submit = (data) => {
    const requestData = {
      ...data,
      numeroTicket: numeroTicket,
    };
    setIsSubmit(true);
    store(VALIDATION_VENTE, "application/json", requestData)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Validation de vente éffectuée avec succès");
          setIsSubmit(null);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };

  return (
    <>
      {isSubmit !== null ? (
        <form
          className="shadow-sm border rounded w-fit lg:w-full p-8"
          onSubmit={handleSubmit(submit)}
        >
          <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
            Validation de vente
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Veuillez renseigner les champs suivants pour valider la vente
          </p>
          <div className="my-4 space-y-4">
            <div className="my-2">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text text-sm">
                    Status de validation <span className="text-red-500">*</span>
                  </span>
                </div>
                <select
                  {...register("estApprouve", { required: true })}
                  className="select select-bordered w-full"
                  onChange={(e) => {
                    setStatusOk(e.target.value);
                  }}
                >
                  <option disabled selected>
                    Selectionnez un status
                  </option>
                  <option value={true}>Validé</option>
                  <option value={false}>Réjété</option>
                </select>
              </label>
            </div>

            <div className="my-2">
              <label htmlFor="" className="text-sm">
                Commentaire
              </label>
              <textarea
                {...register("commentaire")}
                placeholder="Votre commentaire"
                className="textarea textarea-bordered textarea-sm w-full"
              ></textarea>
            </div>
            <div className="w-full">
              <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
            </div>
          </div>
        </form>
      ) : (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={ok} height={80} width={80} alt="" />
            <p className="font-light mt-2  text-sm">
              Validation de vente éffectuée avec succès
            </p>
          </div>
        </div>
      )}

      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <button
            disabled={isSubmit !== null ? true : false}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={() => {
              window.history.back();
              localStorage.removeItem("numeroTicket");
            }}
          >
            Terminer
          </button>
        </div>
      </div>
    </>
  );
};
